var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-datepicker',{staticClass:"border-sm bg-white shadow-sm",attrs:{"value-as-date":"","locale":"en","boundary":"0px"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }